import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import {
  CreateGeoMultiMethodResponce,
  GeoMultiMethodCreateRequestPayload,
} from '@/models/ps-management/multi-methods.model';

export default class CreateGeoMultiMethodRequest
  extends ApiResourceMethod<string> {
  public perform(data: GeoMultiMethodCreateRequestPayload): Promise<string> {
    return this.performer.requestWithMapper(
      { data },
      (payload: BaseResponse<CreateGeoMultiMethodResponce>) => payload.headers['content-location'],
    );
  }
}
